import React, { useState, useEffect, useRef } from 'react';
import { Paper, Box, IconButton, Typography, Link, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import BusinessIcon from '@mui/icons-material/Business';
import InventoryIcon from '@mui/icons-material/Inventory';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BuildIcon from '@mui/icons-material/Build';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ApprovalIcon from '@mui/icons-material/Approval';
import DomainIcon from '@mui/icons-material/Domain';
import TitleBreadCrumbsContainer from '../../../containers/common/breadcurmbs/TitleBreadCrumbsContainer';
import ActionButtons from '../buttons/ActionButtons';

const getTitleIcon = (icon) => {
  switch (icon) {
    case 'partner': return <BusinessIcon />;
    case 'product': return <InventoryIcon />;
    case 'user': return <AccountCircleIcon />;
    case 'taxbill': return <ReceiptIcon />;
    case 'pay': return <PriceCheckIcon />;
    case 'chance': return <AccountTreeIcon />;
    case 'tech': return <BuildIcon />;
    case 'dashboard': return <DashboardIcon />;
    case 'approval': return <ApprovalIcon />;
    case 'depart': return <DomainIcon />;
    default: return '';
  }
};

const TitleBox = ({
  edit,
  remove,
  isInitPwd,
  menuName,
  titleData,
  menuLink,
  handleEdit,
  handleRemove,
  handleInitPwd,
  handleGoBack,
  icon,
  editBtnText,
  editDelText,
}) => {
  const containerRef = useRef(null);
  const [isModal, setIsModal] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      const insideModal = !!containerRef.current.closest('.MuiDialog-root, .MuiDrawer-root, .MuiModal-root');
      setIsModal(insideModal);
    }
  }, []);

  return (
    <div ref={containerRef}>
      <Paper sx={{ backgroundColor: '#fafafa' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            {!isModal && (
              <Box sx={{ px: 1 }}>
                <IconButton size="small" onClick={handleGoBack}>
                  <ArrowBackIcon aria-label="goBack" />
                </IconButton>
              </Box>
            )}

            <Box
              sx={{
                py: 1,
                flexGrow: 1,
                display: 'flex',
                flexDirection: { xs: 'row' },
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  mx: 1,
                  color: '#fff',
                  bgcolor: 'info.main',
                  borderRadius: 1,
                  p: 0.3,
                }}
              >
                {getTitleIcon(icon)}
              </Box>

              <Box sx={{ ml: isModal ? 1 : 2 }}>
                <TitleBreadCrumbsContainer title={menuName} />
                <Typography variant="subtitle1" component="div" color="primary.main">
                  {titleData?.name}
                </Typography>
              </Box>
            </Box>
          </Box>
          <ActionButtons
            edit={edit}
            remove={remove}
            isInitPwd={isInitPwd}
            handleEdit={handleEdit}
            handleRemove={handleRemove}
            handleInitPwd={handleInitPwd}
            editBtnText={editBtnText}
            editDelText={editDelText}
          />
        </Box>
      </Paper>
    </div>
  );
};

export default TitleBox;
